export default "/assets/images/CC-product-showcase-02.749ab0d64ec9790d.jpg";